import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import Alignment, { HorizontalAlignments, VerticalAlignments } from "../../modules/Alignment";
import Button, { ButtonColor, ButtonKind } from "../../elements/Button";
import Grid from "../../elements/Grid";
import Heading, { types } from "../../elements/Heading";
import Link from "../../elements/Link";
import Typography from "../../elements/Typography";
import { Rank, Sizes, VerticalSpacingSizes } from "../../core/types";
import SemanticArticle from "../../elements/SemanticArticle";
import SeparatedList from "../SeparatedList";
import Price from "../../elements/Price";
import { VerticalSpacing } from "../../elements/VerticalSpacing";

var ProductInfo = function ProductInfo(_ref) {
  var buttonHref = _ref.buttonHref,
      buttonText = _ref.buttonText,
      categoryItems = _ref.categoryItems,
      categoryItemsSeparator = _ref.categoryItemsSeparator,
      categoryTitle = _ref.categoryTitle,
      ctaTitle = _ref.ctaTitle,
      description = _ref.description,
      featureItems = _ref.featureItems,
      featureItemsSeparator = _ref.featureItemsSeparator,
      featureTitle = _ref.featureTitle,
      linkHref = _ref.linkHref,
      linkText = _ref.linkText,
      currency = _ref.currency,
      price = _ref.price,
      priceSeparator = _ref.priceSeparator,
      per = _ref.per,
      title = _ref.title;
  var getClassName = getClassNameFactory(ProductInfo.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement(SemanticArticle, null, /*#__PURE__*/React.createElement(Grid, {
    variant: "3/4,1/4"
  }, /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement(VerticalSpacing, {
    size: VerticalSpacingSizes.XS
  }, /*#__PURE__*/React.createElement(Heading, {
    rank: Rank.Second,
    type: types.XtraSmall
  }, /*#__PURE__*/React.createElement("b", null, title)), categoryTitle && categoryItems && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "category"
    })
  }, /*#__PURE__*/React.createElement("span", null, categoryTitle, " "), /*#__PURE__*/React.createElement(SeparatedList, {
    items: categoryItems,
    separator: categoryItemsSeparator
  }))), /*#__PURE__*/React.createElement(VerticalSpacing, {
    size: VerticalSpacingSizes.S
  }, /*#__PURE__*/React.createElement(Typography, {
    type: Sizes.XTRASMALL
  }, description)), /*#__PURE__*/React.createElement(VerticalSpacing, {
    size: VerticalSpacingSizes.L
  }, featureTitle && featureItems && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "feature"
    })
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, featureTitle)), /*#__PURE__*/React.createElement(SeparatedList, {
    items: featureItems,
    separator: featureItemsSeparator
  }))), /*#__PURE__*/React.createElement(Typography, {
    type: Sizes.XTRASMALL
  }, /*#__PURE__*/React.createElement(Link, {
    href: linkHref
  }, /*#__PURE__*/React.createElement("strong", null, linkText)))), /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement(Alignment, {
    vertical: VerticalAlignments.CENTER,
    horizontal: HorizontalAlignments.CENTER
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "cta"
    })
  }, /*#__PURE__*/React.createElement(VerticalSpacing, {
    size: VerticalSpacingSizes.S
  }, /*#__PURE__*/React.createElement("div", null, ctaTitle), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "price"
    })
  }, /*#__PURE__*/React.createElement(Price, {
    price: price,
    currency: currency,
    period: per,
    separator: priceSeparator
  }))), /*#__PURE__*/React.createElement(VerticalSpacing, {
    size: VerticalSpacingSizes.S
  }, /*#__PURE__*/React.createElement(Button, {
    kind: ButtonKind.BUTTON,
    color: ButtonColor.PRIMARY,
    href: buttonHref
  }, buttonText))))))));
};

ProductInfo.defaultProps = {
  categoryItemsSeparator: ", ",
  featureItemsSeparator: ", ",
  priceSeparator: "/",
  currency: "USD",
  per: "mo"
};
ProductInfo.displayName = "ProductInfo";
export default ProductInfo;